export const BACKGROUND_PATTERNS = {
  none: {
    id: "none" as const,
    labelKey: "settings.backgroundPattern.none",
    className: "deck-pat-none",
  },
  dots: {
    id: "dots" as const,
    labelKey: "settings.backgroundPattern.dots",
    className: "deck-pat-dots",
  },
  stripes: {
    id: "stripes" as const,
    labelKey: "settings.backgroundPattern.stripes",
    className: "deck-pat-stripes",
  },
  grid: {
    id: "grid" as const,
    labelKey: "settings.backgroundPattern.grid",
    className: "deck-pat-grid",
  },
  waves: {
    id: "waves" as const,
    labelKey: "settings.backgroundPattern.waves",
    className: "deck-pat-waves",
  },
  checkerboard: {
    id: "checkerboard" as const,
    labelKey: "settings.backgroundPattern.checkerboard",
    className: "deck-pat-checkerboard",
  },
  cross: {
    id: "cross" as const,
    labelKey: "settings.backgroundPattern.cross",
    className: "deck-pat-cross",
  },
} as const;

export type BackgroundPatternType = keyof typeof BACKGROUND_PATTERNS;

/** @deprecated Use BackgroundPatternType instead */
export type BackgroundPattern = BackgroundPatternType;

export const DEFAULT_BACKGROUND_PATTERN: BackgroundPatternType = "waves";

/**
 * 背景パターンに対応するCSSクラス名を取得
 */
export function getBackgroundPatternClass(pattern: BackgroundPatternType): string {
  return (
    BACKGROUND_PATTERNS[pattern]?.className ??
    BACKGROUND_PATTERNS[DEFAULT_BACKGROUND_PATTERN].className
  );
}

/**
 * 全ての背景パターンのリストを取得
 */
export function getBackgroundPatternList() {
  return Object.values(BACKGROUND_PATTERNS);
}
